export default __webpack_public_path__ + "static/media/perklink-orange.39f565e7.png";